<template>
  <div class="">
    <m-content-wrapper content-type="page" :slicer="slicer">
      <template v-slot="{contents,pagination,changePageFunction}">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 mb-2" v-for="content in contents" :key="content.id">
              <m-a  class="text-decoration-none pages-archive-1-card"
                   :href="{name:'SinglePage',params:{slug:content.slug}}">
                <component :is="pageCard" :content="content"/>
              </m-a>
            </div>
          </div>
          <div class="row" v-if="paginate">
            <div class="col-lg-12">
              <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
            </div>
          </div>
        </div>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mCard2 from "../../Cards/Card2";
import mA from "../../Tags/A";
import mIcon from "../../Icons/Icon";
import mPaginate1 from "../../Pagination/Paginate1";
import {Cards} from '../Cards/Cards'

export default {
  name: "Pages1",
  components: {mContentWrapper, mCard2, mA, mIcon, mPaginate1, ...Cards},
  props: {
    slicer: {
      default: Infinity,
    },
    paginate: {
      default: true,
    },
    pageCard: {
      options: Object.keys(Cards),
      default: 'mPageCard2'
    },
  },
};
</script>
